define('view/reporting/reporting.view',['require','exports','module','underscore','blockit','uikit/uikit','templates','fukit'],function(require, exports, module) {
  // prettier-ignore
  var _         = require('underscore'),
      BlocKit   = require('blockit'),
      UIKit     = require('uikit/uikit'),
      Templates = require('templates');
      config    = require('fukit').config;

  var ReportIFrameView = UIKit.ItemView.extend({
    template: Templates.App['reporting.page'],

    options: {
      parentView: null,
      reportUrl: config.get('reporting.iframe.url')
    },
    onRender: function() {

      _.delay(function() {
        var token = localStorage.getItem('fk_accessToken');
        // Get a reference to the iframe element's window handle.
        var dareUi = document.getElementById('dare-ui').contentWindow;

        // Send the token by postMessage() to the iframe's window handle.
        console.log("sending token to iframe",token)
        dareUi.postMessage(token,'*');

        // The dare-ui iframe will respond with an acknowledgement
        function handleMessageFromIframe(e) {
          if (e.source == dareUi) {
            console.log("Message from iframe: " + e.data);
          } else {
            console.log("Message from other source: " + JSON.stringify(e));
          }
        }

        // Register a listener for this example page to receive the ACK back from the iframe.
        if (window.addEventListener) {
          window.addEventListener('message', handleMessageFromIframe, false);
        } else if (window.attachEvent) { // ie8
          window.attachEvent('onmessage', handleMessageFromIframe());
        }
      },2000);

    }

  });

  var ReportingView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      modals: {},
      root: {
        type: BlocKit.FullWidthLayoutView,
        // pageHeader: {
        //   headerText: 'Saved Reports',
        //   actions: [],
        // },

        contentColumn: {
          components: [
            {
              type: ReportIFrameView
            },
          ],
        }, //end of contentColumn
      },
    },

  });

  module.exports = ReportingView;
});

